import { TokenService } from '@/services/storage/tokenStorage.service'

export default {
  authenticating: false,
  accessToken: TokenService.getToken(),
  authenticationErrorCode: 0,
  authenticationError: '',
  refreshTokenPromise: null
}
